import React from 'react';
import  { MaterialOptionProps } from '../interfaces';
import './MaterialOption.scss';

const MaterialOption: React.FC<MaterialOptionProps> = ({
  material,
  isSelected,
  disabled,
  iconUrl,
  toneClass,
  onSelect,
}) => (
  <span
    onClick={() => {
      if (!disabled) onSelect(material);
    }}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (!disabled) onSelect(material);
      }
    }}
    className={`material-option ${toneClass} ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
    title={material.materialName}
    aria-label={material.materialName}
    role="button"
    aria-disabled={disabled}
    tabIndex={disabled ? -1 : 0}
  >
    <span className="material-option__swatch">
      {iconUrl && <img src={iconUrl} alt={material.materialName} />}
    </span>
  </span>
);

export default React.memo(MaterialOption);
